import { BaseProductApi, ConflictAction } from '@inter-ikea-storageone/range';
import { ConnectionUtils } from '@inter-ikea-core/core';
export class SmastadProductApi extends BaseProductApi {
    performAction(action, params) {
        switch (action) {
            case ConflictAction.ADD_PRODUCT:
                this.add(params.productId, params.position);
                break;
            case ConflictAction.ADD_PRODUCT_TO_TARGET:
                {
                    const entity = this.coreServices.sceneManager.findEntity(params.parentEntityId);
                    if (!entity)
                        return;
                    const placementResult = this.addToTarget(params.productId, entity);
                    if (placementResult.valid &&
                        placementResult.placedEntity &&
                        params.entitiesToAddToCollidingEntityProductIds) {
                        params.entitiesToAddToCollidingEntityProductIds.forEach((productId) => {
                            if (!placementResult.placedEntity)
                                return;
                            this.addToTarget(productId, placementResult.placedEntity);
                        });
                    }
                }
                break;
            case ConflictAction.DELETE_ENTITY: {
                const entity = this.coreServices.sceneManager.findEntity(params.entityId);
                if (entity) {
                    ConnectionUtils.disconnectAndDisposeEntityAndHierarchy(entity);
                }
                break;
            }
            case ConflictAction.ADD_ENTITY_TO_TARGET:
                {
                    const parentEntity = this.coreServices.sceneManager.findEntity(params.parentEntityId);
                    if (!parentEntity)
                        return;
                    const placementResult = this.placementService.snapToTarget(params.entity, parentEntity);
                    if (placementResult.valid && placementResult.placedEntity) {
                        this.placementService.dissolveEntity(placementResult.placedEntity);
                    }
                    if (placementResult.valid &&
                        placementResult.placedEntity &&
                        params.entitiesToAddToCollidingEntityProductIds) {
                        params.entitiesToAddToCollidingEntityProductIds.forEach((productId) => {
                            if (!placementResult.placedEntity)
                                return;
                            this.addToTarget(productId, placementResult.placedEntity);
                        });
                    }
                }
                break;
            default:
                throw new Error('Unkown action');
        }
    }
    /**
     *
     * @override
     */
    getDefaultLeg() {
        return '20331198';
    }
}
//# sourceMappingURL=SmastadProductApi.js.map